module.exports = __webpack_public_path__ + "img/plan-img-01.a0bfdcb8.png";